import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

export class UsersVisitResponseUser {
    name: string;
    date: Date;
}

class GetInstanceStatsUsersVisitResponse {
    users: UsersVisitResponseUser[]
}

export function getInstanceStatsUsersVisit(instance_id: number): Promise<AxiosResponse<GetInstanceStatsUsersVisitResponse>>{
    return Cirus.get(`/instance/${instance_id}/stats/users-visit`);
}